






























































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import Heading from '@/modules/common/layout/components/shared/Heading.vue'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  components: {
    Heading,
    AlertNotification,
    BaseButton
  }
})

export default class WriterIndexPage extends Vue {
  @Prop() message_board!: MessageBoardCollection

  slide = 'slide0'

  carouselBg(type) {
    if (type === 'warning') {
      return 'bg-tes-gradient-orange'
    } else if (type === 'success') {
      return 'bg-tes-gradient-green'
    } else if (type === 'info') {
      return 'bg-tes-gradient-blue'
    } else if (type === 'danger') {
      return 'bg-tes-gradient-red'
    }
  }
}
